import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "moon", "sun"]

  connect() {
    this.boundTurboLoad = this.syncTheme.bind(this)
    document.addEventListener("turbo:load", this.boundTurboLoad)
    this.syncTheme()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundTurboLoad)
  }

  toggle() {
    const isDark = document.documentElement.classList.contains("dark")
    const next = isDark ? "light" : "dark"
    this.animateIcon()
    this.applyTheme(next)
    window.localStorage.setItem("theme", next)
  }

  syncTheme() {
    const saved = window.localStorage.getItem("theme")
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
    const theme = saved || (prefersDark ? "dark" : "light")
    this.applyTheme(theme)
  }

  applyTheme(theme) {
    document.documentElement.classList.toggle("dark", theme === "dark")
    this.updateButton(theme)
  }

  updateButton(theme) {
    const isDark = theme === "dark"
    if (this.hasMoonTarget) this.moonTarget.classList.toggle("hidden", isDark)
    if (this.hasSunTarget) this.sunTarget.classList.toggle("hidden", !isDark)
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute(
        "aria-label",
        isDark ? "Switch to light mode" : "Switch to dark mode"
      )
    }
  }

  animateIcon() {
    if (!this.hasButtonTarget) return
    this.buttonTarget.classList.add("theme-toggle-animate")
    window.setTimeout(() => {
      this.buttonTarget.classList.remove("theme-toggle-animate")
    }, 180)
  }
}
